// extracted by mini-css-extract-plugin
export default {"icon":"policyHolderClaimReviewAcceptedRejectedWordings_icon__ujd9H","accepted-wordings":"policyHolderClaimReviewAcceptedRejectedWordings_accepted-wordings__T24oL"};